export default {
  form: {
    address: {
      delivery: {
        placeholder: 'Busca tu dirección de entrega',
      },
      placeholder: 'Introduce tu dirección para encontrar el local más cercano',
    },
  },
  toasts: {
    failed_to_load_stores: 'Error al cargar las tiendas, por favor recarga la página',
  },
  errors: {
    no_delivery_companies: 'Entrega no disponible para esta dirección',
    delivery_not_available: 'Lo sentimos, actualmente no ofrecemos entrega a domicilio',
    location_unavailable: 'No se pudo acceder a tu ubicación, activa los permisos o introduce la dirección manualmente',
    location_lookup_failed: 'No se pudo encontrar tu dirección, por favor inténtalo de nuevo',
    address_suggestions_unavailable: 'No se pudieron cargar las sugerencias de direcciones.',
  },
  buttons: {
    use_current_location: 'Usar mi ubicación actual',
    locating: 'Buscando tu ubicación…',
    retry: 'Intentar de nuevo',
  },
};
